import React, {Component} from 'react';
import '@assets/sass/components/form/_form-controls.scss';

export default class Input extends Component {
    constructor(props) {
        super(props);
        this.input = React.createRef();

        this.handleChange = this.handleChange.bind(this);
    }


    state = {
        value: '',
        typing: false,
        typingTimeout: 0,
    };

    handleChange(event) {
        const {onChange} = this.props;
        const self = this;

        if (self.state.typingTimeout) {
            clearTimeout(self.state.typingTimeout);
        }

        self.setState({
            name: event.target.value,
            typing: false,
            typingTimeout: setTimeout(function() {
                    onChange(self.state.name);
            }, 1000)
        });
    }

    setValue(value) {
        this.setState({
            value: value
        });
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    }

    render() {
        const {
            iconPos,
            icon,
            placeholder,
            type = 'text',
            value,
            onFocus,
            onBlur,
            className
        } = this.props;

        const iconPositionClass = iconPos !== null ? 'form-input-icon--' + iconPos : null;
        return (
            <div className="form-input-container">
                {icon && <img className={'form-input-icon ' + iconPositionClass} src={icon} alt='amenities'/>}
                <input
                    id={this.props.id}
                    placeholder={placeholder}
                    type={type}
                    value={value}
                    onChange={this.handleChange}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    ref={this.input}
                    className={className ? className : ''}
                />
            </div>
        )
    }
}